import React from "react";
import { useTranslation } from "react-i18next";
import { TableTabs } from "@/components/DataTable/TableTabs";
import { ScheduledEventsTab } from "./ScheduledEventsTab";
import { CompletedEventsTab } from "./CompletedEventsTab";

export const GamesAndLiveEventsTabs = () => {
  const { t } = useTranslation();

  return (
    <div>
      <TableTabs
        activeTab={0}
        className="rounded-lg border"
        tabs={[
          {
            label: t("gamesAndLiveEvents.table.tabs.scheduled"),
            children: <ScheduledEventsTab />,
          },
          {
            label: t("gamesAndLiveEvents.table.tabs.completed"),
            children: <CompletedEventsTab />,
          },
        ]}
      />
    </div>
  );
};
